import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { inject } from '@vercel/analytics';
import { enableProdMode } from '@angular/core';
import { injectSpeedInsights } from '@vercel/speed-insights';

import { environment } from '@environments/environment';

import { AppModule } from './app/app.module';

if (environment.enableTracking) {
  inject({
    mode: environment.production ? 'production' : 'development',
  });
  injectSpeedInsights({
    framework: 'angular',
  });
}

if (environment.production) enableProdMode();

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
